<!--
 * @Description: 新能源油品库
 * @Author: ywz
 * @Date: 2025-07-15
 -->
<template>
  <div>
    <el-form class="table-search-bar"
             :model="searchForm"
             ref="searchForm"
             inline
             label-width="100px">
      <el-form-item label="库区名称"
                    prop="oilDepotCode">
        <el-select v-model="searchForm.oilDepotCode">
          <el-option v-for="item in oilDepotOptions"
                     :key="item.code"
                     :label="item.name"
                     :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="油罐编码"
                    prop="oilTankCode">
        <el-select v-model="searchForm.oilTankCode"
                   clearable
                   filterable>
          <el-option v-for="item in formOilTankOptions"
                     :key="item.oilTankCode"
                     :label="item.oilTankCode"
                     :value="item.oilTankCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物料名称"
                    prop="itemName">
        <el-input placeholder="输入物料名称"
                  v-model="searchForm.itemName">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="handleSearch"
                   icon="el-icon-search">查 询</el-button>
        <el-button type="primary"
                   @click="reset">重 置</el-button>
        <el-button type="primary"
                   @click="analyse">出入库记录</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="inventoryCurrentList"
              style="width: 100%"
              tooltip-effect="light">
      <el-table-column prop="reservoirAreaName"
                       label="库区名称"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="oilTankCode"
                       label="油罐编码"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="itemCode"
                       label="物料名称"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="itemName"
                       label="物料名称"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="openingQuantity"
                       label="期初库存"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="storageQuantity"
                       label="入库数量"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="outQuantity"
                       label="出库数量"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="blendQuantity"
                       label="调和数量"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="adjustQuantity"
                       label="调整数量"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="nowQuantity"
                       label="库存量"
                       :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <el-pagination class="pagination"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="listState.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="listState.total"
                   background>
    </el-pagination>
    <!-- <el-row class="export-row"
            type="flex"
            justify="end">
      <div class="mr10">
        每页
        <el-select class="width100"
                   v-model="pageSize"
                   @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        条
      </div>
      <div class="mr10">
        第
        <el-select class="width100"
                   v-model="pageNo">
          <el-option v-for="item in pageOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        页
      </div>
      <div class="">
        <el-button type="primary"
                   @click="handleExportCSV">导出为CSV文件</el-button>
      </div>
    </el-row> -->
    <add-or-edit-dialog :show.sync="dialogVisible" width="800px">
    </add-or-edit-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import addOrEditDialog from './addOrEditDialog.vue'
export default {
  name: 'inventoryCurrent',
  components: {
    addOrEditDialog
  },
  data () {
    return {
      dialogVisible: false,
      searchForm: {},
      formOilTankOptions: [],
      pageNo: 1,
      pageSize: 100,
      sizeOptions: [
        {
          label: '100',
          value: 100
        },
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        }
      ],
      oilDepotCode: '',
      oilDepotOptions: [
        { code: 'PJPSK', name: '盘锦盘山油库' },
        { code: 'JHK', name: '天津静海油库' },
        { code: 'CMK', name: '山西昌茂油库' }
      ]
    }
  },
  computed: {
    ...mapState({
      inventoryCurrentList: (state) => state.inventoryCurrent.list,
      listState: (state) => state.inventoryCurrent.listState
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.pageSize
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    this.handleSearch()
    this.getDicOilTankList({ reservoirAreaCode: 'XNYYPK' }).then((res) => {
      if (res) {
        this.formOilTankOptions = res.map((item) => {
          return {
            oilTankCode: item.oilTankCode,
            oilTankName: item.oilTankName
          }
        })
      }
    })
  },
  methods: {
    ...mapActions([
      'getInventoryCurrentList',
      'getDicOilTankList'
    ]),
    reset () {
      this.$refs['searchForm'].resetFields()
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.getInventoryCurrentList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getInventoryCurrentList({ pageNo: val })
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.pageNo = 1
    },
    analyse () {
      this.dialogVisible = true
    },
    // 查询
    handleSearch () {
      const { oilTankCode, itemName, oilDepotCode } = this.searchForm
      this.getInventoryCurrentList({ reservoirAreaCode: 'XNYYPK', oilTankCode, itemName, oilDepotCode })
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-btn {
  display: inline-block;
}
.width100 {
  width: 100px;
}
.export-row {
  margin-top: 10px;
}
.mr10 {
  margin-right: 10px;
}
</style>
